/**
 * API 列表
 */

// thymeleaf模板写入 打包删除，打包完成后再写入diest index.html

// <meta property=og:image:type content=image/jpeg> <meta property="og:title" th:content="${title}" />
// <meta property="og:url" th:content="${url}" />
// <meta property="og:description" th:content="${description}" />

// <meta property="og:image"
//   th:content="${image}+'?x-oss-process=image/resize,m_pad,h_314,w_210/format,jpeg,color_333333'" />
// <meta property="og:image:width" content=210 />
// <meta property="og:image:height" content=314 />

//  end================

const SERVER = {
  // URL: "https://devapi.nowbook.sup.services/",
  // URL: "10.10.10.31",
  URL: "https://api.nowbook.sup.services/", //知书生产域名
//   URL: "https://devapi.nowbook.cctechhk.net/", // yuema-dev
 //  URL:"https://devapi-nowbook.runderful.cn/",  //新的yuema-dev
   SHARE_DOMAIN: 'https://zhishu.runderful.cn/', // 分享域名
//   SHARE_DOMAIN: 'https://test-zhishu.runderful.cn/', // 分享测试域名
  //SHARE_DOMAIN: 'https://test-zhishu.runderful.cn/', // 分享测试域名
// SHARE_DOMAIN:'http://192.168.2.21:8081/',//'http://192.168.1.101:8081/',//'http://192.168.2.21:8081/',//'http://192.168.137.226:8081/',//
  // URL: "http://10.10.10.115/",//123

  APPID: "zhishu", //配置APPID

  DEV: false, // 环境设置

  PAYPAL_URL_DOMIN: "https://www.paypal.com/sdk/js?client-id=AQtmtXEthyj-_d4u57UdK26fDwfXuFeON0Rw5g3rdIsqpJeJ8Htajt1lNQ9bJbjJqSYPpxqmb8eWnK6c&currency=HKD"
  ,PAYPAL_URL_DEV: "https://www.paypal.com/sdk/js?client-id=AbCwdPFxB0efL4lUte_Pm--JCzuayKeSA7RiOWcjDWN3twEGMArGPwBDdcMxKA3XAIkY5u4Kr4IM5_93&currency=HKD"
  ,PAYPAL_URL:""
};

const CONFIG = {
  // 合并请求
  MERGEREQUEST: "/api/media/index/mergeRequest",

  USERDETAIL: "/api/user/getUser",

  REFRESHSESSION: "/api/user/refreshSession", //更新用户session

  //获取多媒体区块数据接口
  MEDIABLOCK: {
    GET: "/api/media/cms/getBlocklistByCode"
  },

  // 专栏接口
  COLUMN: {
    // 获取专栏
    GET: "/api/media/list/shareGet",
    GETList: "/nowbook/media/share/getCanTryPlayUrls"
  },

  //shareGet

  GETSHARE: "/api/media/list/shareGet",

  GetJsSignInfo: "/api/media/weixin/getJsSignInfo",

  //多媒體文件接口
  MEDIA: {
    GET: "/api/media/data/shareGet",
    GETBLOCKBYCODE: "/api/media/cms/getBlocklistByCode"
  },

  //自由模板数据
  MEDIAH5: "/api/media/h5/get",

   //知書幣相關接口
   COIN: {
    CONFIG: "/api/media/coin/config", //充值知書幣配置
    BUYCOIN: "/api/media/coin/buy", //充值購買知書幣
    ACCOUNT: "/api/media/coin/account", //查询余额
    PAYCOIN: "/api/media/coin/pay", //支付
    ORDERQUERY: "/api/sale/order/query", //查询充值记录
    EXCHANGEZS: "/api/media/coin/cardVerify", //兑换知書幣
    payList: "/api/media/coin/getPayTypes", //支付方式
    paypalh5Buy: "/api/media/coin/h5Buy",
    sharePayResult: "/api/media/coin/sharePayResult",
    queryOrder: "/api/sale/order/query" // 查询H5的支付订单
  },

  GETCOUPON: "api/activity/share/query", // 活動頁面詳情
  RECEIVE: "api/activity/share/receive", //用户领取优惠券
  ClickSave:"/api/media/h5/click/save",

  USER: {
    TELVERIFICATIONCODE: "/api/user/getTelVerificationCode", //發送手機驗證碼
    TELLOGIN: "/api/user/loginTel", //手機號註冊登錄
    REGISTER: "/api/user/register", //郵箱註冊
    ANONYMOUS: "/api/user/anonymousUserSwitch/get", //静默登录开关
    LOGIN: "/api/user/login", //登錄
    EMAILVERIFICATIONCODE: "/api/user/getVerificationCode", //發送郵箱驗證碼
    THIRDLOGIN: "/api/user/thirdLogin", //第三方登录
    BINDEMAIL: "/api/user/bindEmail", //綁定郵箱
    FORGETPASSWORD: "/api/user/forgetPassword", //忘記密碼
    FORGETCODE: "/api/user/forgetCode", //忘記密碼獲取郵箱驗證碼
  },

  NEWS: {
    GET_MESSAGE: "/api/app/message/query", //查询
    SET_READ: "/api/app/message/setRead", //更新消息状态为已读
    MES_COUNT: "/api/app/message/getUnreadCount", //获取未读消息数量
    MES_DETALI: "/api/app/message/get", //获取消息詳情
    PUB_DETALI: "/api/ads/adsSchedule/getAdsMaterial", //廣告詳情
    GET_SWITCH: "/api/app/appPushMessageSwitch/findByUserId", //獲取接受狀態
    UPDATE_SWITCH: "/api/app/appPushMessageSwitch/save" //更新狀態
  },

  NOWBOOK: {
    SHARE_VIDEO_URL: "/nowbook/media/share/video/url/",
    SHARE_EPUB_TRIAL_READ: "/nowbook/media/share/epub/trial/read/",
    SHARE_EPUB_TRIAL_PREPARE: "/nowbook/media/share/epub/trial/prepare/",
    SHARE_PDF_URL: "nowbook/media/share/pdf/url/",
  }
};
module.exports = {
  CONFIG,
  SERVER
};



// WEBPACK FOOTER //
// ./src/api/apiConfig.js